module.exports = __webpack_public_path__ + "static/media/banner@2x.0f3720f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner@2x.jpg
// module id = 1106
// module chunks = 2